<form [formGroup]="form">
  <app-input-field [control]="form.controls.search" [noLabel]="true" [smallNoLabel]="true" class="headless">
    <input type="text" formControlName="search" placeholder="Search..." />
  </app-input-field>
</form>

<div class="font-list">
  @for (font of fonts(); track font) {
    <div
      class="font-button"
      [attr.data-test-id]="'font_' + font"
      [class.active]="font === (currentFont || defaultFont)"
      (click)="onSelected.emit(font)"
    >
      <div
        class="font-image"
        [style.-webkit-mask-image]="imageLinks.get(font)"
        [style.mask-image]="imageLinks.get(font)"
      ></div>
      @if (font === (currentFont || defaultFont)) {
        <app-svg src="/assets/icons/check.svg" class="some-check"></app-svg>
      }
    </div>
  }
</div>

@if (searchValue() && !fonts().length) {
  <div class="no-results">No results found</div>
}

@if (currentFont && allowFontReset && !searchValue()) {
  <div class="reset-button">
    <app-button-menu-item
      name="reset-font"
      location="font-selection-menu"
      [color]="'simple'"
      icon="undo"
      [fullWidth]="true"
      (onClick)="onSelected.emit(undefined)"
    >
      <span>Reset Font</span>
    </app-button-menu-item>
  </div>
}
@if (allowRemoveOverrides) {
  <div class="reset-button">
    <app-button-menu-item
      name="remove-overrides"
      location="font-selection-menu"
      [color]="'simple'"
      icon="undo"
      [fullWidth]="true"
      (onClick)="onRemoveOverrides.emit()"
    >
      <span>Remove overrides</span>
    </app-button-menu-item>
  </div>
}
